import { ComponentType } from 'react';
import BarChart from '@material-ui/icons/BarChart';
import PieChart from '@material-ui/icons/PieChart';
import DragIndicator from '@material-ui/icons/DragIndicator';
import AccountTree from '@material-ui/icons/AccountTree';
import Edit from '@material-ui/icons/Edit';
import TableChart from '@material-ui/icons/TableChart';

export interface PlaygroundEntry {
  label: string;
  route: string;
  icon: ComponentType<any>;
}

const playgroundNav: PlaygroundEntry[] = [
  { label: 'D3 Charts', route: 'd3', icon: BarChart },
  { label: 'Google Charts', route: 'google', icon: PieChart },
  { label: 'Drag & Drop', route: 'react/dnd', icon: DragIndicator },
  { label: 'Tree View', route: 'react/tree', icon: AccountTree },
  { label: 'Rich Text Editor', route: 'react/editor', icon: Edit },
  { label: 'Data Table', route: 'react/table', icon: TableChart },
];

export default playgroundNav;
